import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesProductionBacklogChart } from "src/components/views/erp/production/productionPlanning/salesBacklogChart/SalesProductionBacklogChart.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/production/salesProductionBacklog")({
	staticData: { title: i18n.t("order_backlog"), legacyViewKey: "salesProductionBacklogPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesProductionBacklogChart />;
}
